import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';

import { FacilityService } from '../../_services/facility.service'

@Component({
    selector: 'app-add-facility-dialog',
    templateUrl: './add-facility.component.html',
    styleUrls: ['./add-facility.component.less']
})
export class AddFacilityDialogComponent implements OnInit {

    private busy: boolean;
    private parentFacility: any;
    private title: string;
    private unit: string;
    private particularsToDate: number;
    private filteredFacilities: any;
    private portId: number;
    private mapId: number;
    private year: number;
    private x: number;
    private y: number;

    constructor(public dialogRef: MatDialogRef<AddFacilityDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
        private snackBar: MatSnackBar,
        private facilityService: FacilityService) {
        this.filteredFacilities = data.facilities;
        this.portId = data.portId;
        this.mapId = data.mapId;
        this.year = data.year;
        this.x = data.x;
        this.y = data.y;
    }

    filter(val: any) {
        if (val && typeof(val) === 'string') {
            const filterValue = val.toLowerCase();
            return this.data.facilities.filter(state => {
                return state.value.Title.toLowerCase().indexOf(filterValue) !== -1;
            });
        }

        return this.data.facilities;
    }

    displayFacilityName(facility: any): string {
        return facility && typeof (facility) === 'object' ? facility.value.Title : null; 
    }

    ngOnInit() {
        this.busy = false;
    }

    add(form) {
        this.busy = true;
        this.dialogRef.disableClose = true;

        this.facilityService.addFacility(this.portId,
            this.parentFacility.value.Type == null ? this.parentFacility.value.Id : this.parentFacility.value.Type.Id,
            // If parent is FacilityType, then parentFacilityId is null
            this.parentFacility.value.Type == null ? null : this.parentFacility.value.Id,
            this.title,
            this.unit,
            this.particularsToDate,
            this.mapId,
            this.year,
            this.x,
            this.y)
            .subscribe(response => {
                let result = response.json().Result;

                this.dialogRef.close({
                    Id: result.Id,
                    FacilityType: this.parentFacility.value.Type == null ? this.parentFacility.value.Id : this.parentFacility.value.Type.Id,
                    ParentFacilityId: this.parentFacility.value.Type == null ? null : this.parentFacility.value.Id,
                    Title: this.title,
                    Unit: this.unit,
                    ParticularsToDate: this.particularsToDate,
                    MapId: this.mapId,
                    Year: this.year,
                    X: this.x,
                    Y: this.y,
                    Children: []
                });

                this.snackBar.open('Facility was added successfully.', null, { duration: 2000 });
            },
            errorResponse => {
                let error = errorResponse.Message;//.json();

                this.snackBar.open('Failed to add new facility.', null, { duration: 2000 });
                this.busy = false;
            });
    }
}



// WEBPACK FOOTER //
// ./Angular/app/port/add-facility/add-facility.component.ts